export const instructorMenu: Menu[] = [
  {
    label: "Dashboard",
    value: "dashboard",
    icon: "home"
  },
  {
    label: "Students",
    value: "students",
    icon: "students"
  },
  {
    label: "Classes",
    value: "classrooms",
    icon: "users"
  },
  {
    label: "Course templates",
    value: "courses",
    icon: "shapes"
  },
  {
    label: "Help",
    value: "help",
    icon: "question-circle"
  }
];

export const adminMenu: Menu[] = [
  {
    label: "Dashboard",
    value: "dashboard",
    icon: "home"
  },
  {
    label: "Students",
    value: "students",
    icon: "students"
  },
  {
    label: "Instructors",
    value: "instructors",
    icon: "teacher"
  },
  {
    label: "Classes",
    value: "classrooms",
    icon: "users"
  },
  {
    label: "Locations",
    value: "locations",
    icon: "map-marker"
  },
  {
    label: "Course templates",
    value: "courses",
    icon: "shapes"
  },
  {
    label: "Help",
    value: "help",
    icon: "question-circle"
  }
];

export const ASSIGNMENTS_MENU: SelectOption[] = [
  // {
  //   value: "assign_lessons",
  //   label: "Assign Lessons"
  // },
  { value: "assign_worksheets", label: "Assign Worksheets" }
];
